import { render, staticRenderFns } from "./CardColumn.vue?vue&type=template&id=83ffe4de&scoped=true&"
import script from "./CardColumn.vue?vue&type=script&lang=js&"
export * from "./CardColumn.vue?vue&type=script&lang=js&"
import style0 from "./CardColumn.vue?vue&type=style&index=0&id=83ffe4de&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ffe4de",
  null
  
)

export default component.exports